import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VuePageTransition from 'vue-page-transition';
import Affix from 'vue-affix';
import lineClamp from 'vue-line-clamp';
import vSelect from 'vue-select';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
import VueResizeObserver from 'vue-resize-observer';
import NinetailedPlugin from '@ninetailed/experience.js-vue';
import DatadogLogger from './services/datadog.service';

import '@bywinona/corefront/dist/style.css';
import './tailwind.css';
import 'nprogress/nprogress.css';

import NProgress from 'nprogress';
window.NProgress = NProgress;

import VueSecureHTML from 'vue-html-secure';

Vue.use(VueSecureHTML);

// Global Component
Vue.component('Pageloader', () =>
  import('./components/onboarding/loaders/IntermediaryLoader')
);

Vue.component('Modal', () => import('./components/partials/Modal.vue'));

Vue.component('WCheckbox', () =>
  import('./components/partials/RadioAndCheckbox.vue')
);

// Ninetailed
Vue.use(NinetailedPlugin, {
  clientId: process.env.VUE_APP_NINETAILED_ID,
  environment:
    process.env.VUE_APP_SERVER === 'production' ? 'main' : 'development',
});

Vue.component('VIcon', () => import('./icon/icon.vue'));

import VueMask from 'v-mask';
Vue.use(VueMask);

import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';

Vue.use(VueCroppie);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

Vue.component('VSelect', vSelect);

Vue.use(VuePageTransition);
Vue.use(Affix);
Vue.use(lineClamp);
Vue.use(VueResizeObserver);

import flatPickr from 'vue-flatpickr-component';
import {
  BootstrapVue,
  IconsPlugin,
  TooltipPlugin,
  PopoverPlugin,
  LayoutPlugin,
} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/scss/theme.scss';
import 'flatpickr/dist/flatpickr.min.css';
import moment from 'moment';
import VueCookies from 'vue-cookies';
Vue.use(LayoutPlugin, { breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] });

Vue.config.productionTip = false;
Vue.use(flatPickr);

Vue.use(BootstrapVue);

Vue.use(require('vue-shortkey'));
Vue.use(IconsPlugin);
Vue.use(TooltipPlugin);
Vue.use(PopoverPlugin);

// Global
Vue.prototype.moment = moment;
Vue.prototype.$ddlogger = new DatadogLogger();

Vue.directive('height', {
  inserted: function (el, binding) {
    const onResizeCallback = binding.value;
    window.addEventListener('resize', () => {
      const height = document.documentElement.clientHeight;
      onResizeCallback({ height });
    });
  },
});

let token = localStorage.getItem('accessToken');

Object.defineProperty(Vue.prototype, '$token', {
  get() {
    return token;
  },
  set(value) {
    token = value;
  },
});

Vue.use(VueCookies);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
